
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en",
      function () {
        return require("private-next-pages/en.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en"])
      });
    }
  